(function () {
  'use strict';

  /* Evitar registrar una segunda instancia si Shopify vuelve a ejecutar el asset. */
  if (
    window.FuzzyardMegaMenu &&
    typeof window.FuzzyardMegaMenu.initAll === 'function'
  ) {
    window.FuzzyardMegaMenu.initAll(document);
    return;
  }

  var megaMenuIdCounter = 0;

  function hydrateDeferredImages(container) {
    if (!container || typeof container.querySelectorAll !== 'function') {
      return;
    }

    var deferredImages = container.querySelectorAll('img[data-fy-src]');

    deferredImages.forEach(function (image) {
      var source = image.getAttribute('data-fy-src');

      if (!source) return;

      image.decoding = 'async';
      image.setAttribute('src', source);
      image.removeAttribute('data-fy-src');
    });
  }

  function hydrateMenuPreview(root) {
    if (!root) return;

    hydrateDeferredImages(root.querySelector('.fy-mega__categories'));
    hydrateDeferredImages(root.querySelector('.fy-mega__panel.is-active'));
  }

  function hydrateImagesFromIntent(target) {
    if (!target || typeof target.closest !== 'function') return;

    var desktopParent = target.closest('.fy-mega-parent');

    if (desktopParent) {
      var menuRoot = desktopParent.querySelector('[data-fy-mega]');
      var categoryTrigger = target.closest('[data-fy-category]');

      hydrateMenuPreview(menuRoot);

      if (menuRoot && categoryTrigger) {
        hydrateDeferredImages(
          menuRoot.querySelector(
            '[data-fy-panel="' +
            categoryTrigger.getAttribute('data-fy-category') +
            '"]'
          )
        );
      }

      return;
    }

    var mobileMenu = target.closest('.mobile-main-menu');

    if (!mobileMenu) return;

    /*
      Wokiee mueve cada submenú móvil a un panel independiente (#mm1, #mm2...).
      Por eso, después de inicializar el drawer, el enlace padre y sus tarjetas ya
      no comparten el mismo <li>. Resolver el href permite hidratar el panel de
      destino durante pointerdown, antes de que empiece la transición visual.
    */
    var currentCategories = target.closest('.fy-mobile-categories');

    if (currentCategories) {
      hydrateDeferredImages(currentCategories);
    }

    var mobileTrigger = target.closest('.mm-next-level[href^="#"]');

    if (mobileTrigger) {
      var destinationSelector = mobileTrigger.getAttribute('href');
      var destinationPanel = null;

      try {
        destinationPanel = mobileMenu.querySelector(destinationSelector);
      } catch (error) {
        destinationPanel = null;
      }

      if (destinationPanel) {
        hydrateDeferredImages(
          destinationPanel.querySelector('.fy-mobile-categories')
        );

        /*
          mmenu clona la tarjeta de origen (imagen incluida) como enlace
          "mm-original-link" al inicio del panel del submenú de segundo
          nivel. Ese clon es un nodo del DOM aparte del original, así que
          también hay que hidratarlo acá.
        */
        hydrateDeferredImages(
          destinationPanel.querySelector('.mm-original-link')
        );

        return;
      }
    }

    /* Compatibilidad con el HTML original, antes de que Wokiee cree los paneles. */
    var mobileParent = target.closest('.mobile-main-menu > ul > li');

    if (mobileParent) {
      hydrateDeferredImages(
        mobileParent.querySelector(':scope > .fy-mobile-categories')
      );
    }
  }

  function initFuzzyardMegaMenu(root) {
    if (!root || root.dataset.fyInitialized === 'true') {
      return;
    }

    root.dataset.fyInitialized = 'true';

    var categoryTriggers = root.querySelectorAll('[data-fy-category]');
    var categoryPanels = root.querySelectorAll('[data-fy-panel]');

    
    function prepareCategoryImage(categoryName) {
      var controlledPanel = root.querySelector(
        '[data-fy-panel="' + categoryName + '"]'
      );
      hydrateDeferredImages(controlledPanel);
    }

    var parentItem = root.parentElement;
    var parentTrigger = parentItem ? parentItem.firstElementChild : null;

    megaMenuIdCounter += 1;

    if (!root.id) {
      root.id = 'fy-mega-menu-' + megaMenuIdCounter;
    }

    if (
      parentTrigger &&
      parentTrigger.tagName &&
      parentTrigger.tagName.toLowerCase() === 'a'
    ) {
      parentTrigger.setAttribute('aria-haspopup', 'true');
      parentTrigger.setAttribute('aria-controls', root.id);
      parentTrigger.setAttribute('aria-expanded', 'false');

      var lastPointerWasTouch = false;

      function setParentExpanded(isExpanded) {
        parentTrigger.setAttribute(
          'aria-expanded',
          isExpanded ? 'true' : 'false'
        );
      }

      function openParentMenu(isTouch) {
        hydrateMenuPreview(root);
        parentItem.classList.remove('is-interaction-closed');

        if (isTouch === true) {
          parentItem.classList.add('is-touch-open');
        }

        setParentExpanded(true);
      }

      function closeParentMenu() {
        parentItem.classList.remove('is-touch-open');
        parentItem.classList.add('is-interaction-closed');
        setParentExpanded(false);
      }

      parentItem.addEventListener('mouseenter', function () {
        if (
          !window.matchMedia ||
          window.matchMedia('(hover: hover)').matches
        ) {
          openParentMenu(false);
        }
      });

      parentItem.addEventListener('mouseleave', function () {
        if (
          !parentItem.classList.contains('is-touch-open') &&
          !parentItem.contains(document.activeElement)
        ) {
          parentItem.classList.remove('is-interaction-closed');
          setParentExpanded(false);
        }
      });

      parentItem.addEventListener('focusin', function () {
        if (!parentItem.classList.contains('is-interaction-closed')) {
          setParentExpanded(true);
        }
      });

      parentItem.addEventListener('focusout', function (event) {
        if (!parentItem.contains(event.relatedTarget)) {
          parentItem.classList.remove('is-interaction-closed');

          if (
            !parentItem.classList.contains('is-touch-open') &&
            !parentItem.matches(':hover')
          ) {
            setParentExpanded(false);
          }
        }
      });

      parentItem.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        event.preventDefault();
        closeParentMenu();
        parentTrigger.focus();
      });

      parentTrigger.addEventListener('pointerdown', function (event) {
        lastPointerWasTouch =
          event.pointerType === 'touch' || event.pointerType === 'pen';
        parentItem.classList.remove('is-interaction-closed');
      });

      parentTrigger.addEventListener('click', function (event) {
        var isTouchInput =
          lastPointerWasTouch ||
          (
            window.matchMedia &&
            window.matchMedia('(hover: none)').matches
          );

        lastPointerWasTouch = false;

        if (
          isTouchInput &&
          !parentItem.classList.contains('is-touch-open')
        ) {
          event.preventDefault();
          openParentMenu(true);
        }
      });
    }

    categoryPanels.forEach(function (panel) {
      var panelName = panel.getAttribute('data-fy-panel');

      if (!panel.id) {
        panel.id = root.id + '-panel-' + panelName;
      }

      panel.setAttribute(
        'aria-hidden',
        panel.classList.contains('is-active') ? 'false' : 'true'
      );
    });

    categoryTriggers.forEach(function (trigger) {
      var triggerName = trigger.getAttribute('data-fy-category');
      var controlledPanel = root.querySelector(
        '[data-fy-panel="' + triggerName + '"]'
      );

      function prepareCategoryImage() {
        hydrateDeferredImages(controlledPanel);
      }

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute(
        'aria-expanded',
        trigger.classList.contains('is-active') ? 'true' : 'false'
      );

      if (controlledPanel) {
        trigger.setAttribute('aria-controls', controlledPanel.id);
      }
    });


    /* ======================================================
       ACTIVAR PRIMER TERCER NIVEL DISPONIBLE

       Ejemplo:
       PASEAR
       → Arneses
       → Regulares / Step In / Strap...
    ====================================================== */

    function activateFirstThirdLevel(panel) {
      if (!panel) return;

      var levelTwoLinks = panel.querySelectorAll('[data-fy-level-two]');
      var thirdGroups = panel.querySelectorAll('[data-fy-third]');

      levelTwoLinks.forEach(function (item) {
        item.classList.remove('is-active');

        if (item.hasAttribute('aria-expanded')) {
          item.setAttribute('aria-expanded', 'false');
        }
      });

      thirdGroups.forEach(function (group) {
        group.classList.remove('is-active');
        group.setAttribute('aria-hidden', 'true');
      });


      var firstWithChildren = panel.querySelector(
        '[data-fy-level-two][data-fy-has-children="true"]'
      );

      if (!firstWithChildren) {
        return;
      }


      var key = firstWithChildren.getAttribute('data-fy-level-two');

      var thirdGroup = panel.querySelector(
        '[data-fy-third="' + key + '"]'
      );


      firstWithChildren.classList.add('is-active');
      firstWithChildren.setAttribute('aria-expanded', 'true');

      if (thirdGroup) {
        thirdGroup.classList.add('is-active');
        thirdGroup.setAttribute('aria-hidden', 'false');
      }
    }



    /* ======================================================
       CAMBIAR CATEGORÍA PRINCIPAL

       ROPA / PASEAR / JUGUETES / CAMAS / COMEDEROS
    ====================================================== */

    function activateCategory(categoryName) {

      categoryTriggers.forEach(function (trigger) {

        var isActive =
          trigger.getAttribute('data-fy-category') === categoryName;

        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

      });


      categoryPanels.forEach(function (panel) {

        var isActive =
          panel.getAttribute('data-fy-panel') === categoryName;

        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');


        if (isActive) {
          activateFirstThirdLevel(panel);
        }

      });

    }



    /* ======================================================
       CARDS SUPERIORES
    ====================================================== */

    categoryTriggers.forEach(function (trigger) {

      var categoryName =
        trigger.getAttribute('data-fy-category');


      /* DESKTOP HOVER */

      trigger.addEventListener('mouseenter', function () {
        prepareCategoryImage(categoryName);
        activateCategory(categoryName);
      });


      /* ACCESIBILIDAD CON TECLADO */

      trigger.addEventListener('focus', function () {
        prepareCategoryImage(categoryName);
        activateCategory(categoryName);
      });


      /*
        Mientras no hayas configurado una URL,
        evitamos que "#" haga saltar la página arriba.
      */

      trigger.addEventListener('click', function (event) {

        var href = trigger.getAttribute('href');

        if (!href || href === '#') {
          event.preventDefault();
          prepareCategoryImage(categoryName);
          activateCategory(categoryName);
        }

      });

    });



    /* ======================================================
       SEGUNDO NIVEL → TERCER NIVEL
    ====================================================== */

    categoryPanels.forEach(function (panel) {

      var levelTwoLinks =
        panel.querySelectorAll('[data-fy-level-two]');


      levelTwoLinks.forEach(function (link) {

        var linkKey = link.getAttribute('data-fy-level-two');
        var linkedThirdGroup = panel.querySelector(
          '[data-fy-third="' + linkKey + '"]'
        );

        if (linkedThirdGroup) {
          if (!linkedThirdGroup.id) {
            linkedThirdGroup.id = root.id + '-third-' + linkKey;
          }

          link.setAttribute('aria-haspopup', 'true');
          link.setAttribute('aria-controls', linkedThirdGroup.id);
          link.setAttribute(
            'aria-expanded',
            link.classList.contains('is-active') ? 'true' : 'false'
          );
          linkedThirdGroup.setAttribute(
            'aria-hidden',
            linkedThirdGroup.classList.contains('is-active') ? 'false' : 'true'
          );
        }

        function activateThirdLevel() {

          var hasChildren =
            link.getAttribute('data-fy-has-children') === 'true';


          var allLevelTwo =
            panel.querySelectorAll('[data-fy-level-two]');


          var allThirdGroups =
            panel.querySelectorAll('[data-fy-third]');


          /* Limpiar estado anterior */

          allLevelTwo.forEach(function (item) {
            item.classList.remove('is-active');

            if (item.hasAttribute('aria-expanded')) {
              item.setAttribute('aria-expanded', 'false');
            }
          });


          allThirdGroups.forEach(function (group) {
            group.classList.remove('is-active');
            group.setAttribute('aria-hidden', 'true');
          });


          /*
            Si no tiene subcategorías:
            dejamos libre la tercera columna.
          */

          if (!hasChildren) {
            return;
          }


          var key =
            link.getAttribute('data-fy-level-two');


          var thirdGroup =
            panel.querySelector(
              '[data-fy-third="' + key + '"]'
            );


          link.classList.add('is-active');
          link.setAttribute('aria-expanded', 'true');


          if (thirdGroup) {
            thirdGroup.classList.add('is-active');
            thirdGroup.setAttribute('aria-hidden', 'false');
          }

        }


        link.addEventListener(
          'mouseenter',
          activateThirdLevel
        );


        link.addEventListener(
          'focus',
          activateThirdLevel
        );

      });

    });



    /* ======================================================
       ESTADO INICIAL
    ====================================================== */

    var initialCategory =
      root.querySelector('[data-fy-category].is-active');


    if (initialCategory) {

      activateCategory(
        initialCategory.getAttribute('data-fy-category')
      );

    }

  }



  /* ========================================================
     INICIALIZAR TODOS LOS MEGA MENÚS FUZZYARD
  ======================================================== */

  function initAllFuzzyardMenus(scope) {

    var context =
      scope && typeof scope.querySelectorAll === 'function'
        ? scope
        : document;


    if (
      context.matches &&
      context.matches('[data-fy-mega]')
    ) {
      initFuzzyardMegaMenu(context);
    }


    var menus =
      context.querySelectorAll('[data-fy-mega]');


    menus.forEach(function (menu) {
      initFuzzyardMegaMenu(menu);
    });

  }


  window.FuzzyardMegaMenu = {
    initAll: initAllFuzzyardMenus
  };



  /* ========================================================
     ARRANQUE
  ======================================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllFuzzyardMenus
    );

  } else {

    initAllFuzzyardMenus();

  }


  /*
    Iniciar la descarga solo cuando existe intención real de abrir un panel.
    La delegación también cubre los clones de la cabecera sticky y los nodos
    que Shopify sustituya desde el editor.
  */
  function handleImageIntent(event) {
    hydrateImagesFromIntent(event.target);
  }

  document.addEventListener('pointerover', handleImageIntent, true);
  document.addEventListener('focusin', handleImageIntent, true);
  document.addEventListener(
    'pointerdown',
    handleImageIntent,
    { capture: true, passive: true }
  );


  /* Cerrar los megamenús abiertos al interactuar fuera de ellos. */
  document.addEventListener('pointerdown', function (event) {
    var openParents = document.querySelectorAll(
      '.fy-mega-parent > a[aria-expanded="true"]'
    );

    openParents.forEach(function (expandedTrigger) {
      var menuParent = expandedTrigger.closest('.fy-mega-parent');

      if (menuParent && !menuParent.contains(event.target)) {
        menuParent.classList.remove('is-touch-open');
        menuParent.classList.add('is-interaction-closed');
        expandedTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  var desktopMenuIsActive = window.innerWidth >= 1025;

  window.addEventListener('resize', function () {
    var desktopMenuShouldBeActive = window.innerWidth >= 1025;

    if (desktopMenuShouldBeActive === desktopMenuIsActive) return;

    desktopMenuIsActive = desktopMenuShouldBeActive;

    document.querySelectorAll('.fy-mega-parent').forEach(function (menuParent) {
      var menuTrigger = menuParent.firstElementChild;

      menuParent.classList.remove('is-touch-open');
      menuParent.classList.remove('is-interaction-closed');

      if (menuTrigger && menuTrigger.tagName.toLowerCase() === 'a') {
        menuTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  });


  /* Reinicializar únicamente la sección sustituida en el editor de Shopify. */
  document.addEventListener('shopify:section:load', function (event) {
    initAllFuzzyardMenus(event.target);
  });

})();
